

export const treatValidateToken = (session: string, token: string, action: string) => {
    return {
        session : session,
        token: token,
        action: action
    }
}